import Chip from "@mui/material/Chip";
import { STAFF_ROLE } from "../../utils/staffRole";

// สีของ chip ตำแหน่งพนักงาน อ้างอิงดีไซน์ รายงานการหักเงินพนักงาน
// role เป็น free text จาก BE — ค่าที่ไม่รู้จักใช้สไตล์กลาง (เทา)
const ROLE_STYLES: Record<string, { bg: string; color: string }> = {
  [STAFF_ROLE.SALESMAN]: { bg: "#5C69E81A", color: "#5C69E8" },
  [STAFF_ROLE.ASSISTANT]: { bg: "#FDA42C1F", color: "#EE6B00" },
  [STAFF_ROLE.SPARE]: { bg: "#6a6a6a1A", color: "#6a6a6a" },
};

const FALLBACK_STYLE = { bg: "#6a6a6a1A", color: "#6a6a6a" };

interface RoleChipProps {
  role: string;
}

export default function RoleChip({ role }: RoleChipProps) {
  const style = ROLE_STYLES[role] ?? FALLBACK_STYLE;
  return (
    <Chip
      label={role}
      size="small"
      sx={{
        bgcolor: style.bg,
        color: style.color,
        fontWeight: 500,
        borderRadius: "999px",
      }}
    />
  );
}
